import React from "react"
import { publicRoutes } from "router/routes"
import { useTranslation } from "react-i18next"

import { HomeCarousel, HomeCarouselIllustration, SignupForm } from "features/auth/components"
import { Button } from "components/Elements/Button"
import Wave from "components/Elements/Illustrations/Wave"

const SIGNUP_INITIAL_SLIDE_INDEX = 0

export const SignupBicycode: React.FC = () => {
	const [slideIndex, setSlideIndex] = React.useState<number>(SIGNUP_INITIAL_SLIDE_INDEX)

	const { t } = useTranslation()

	return (
		<>
			<Wave className="fixed top-0 left-0 h-screen" />

			<div className="flex flex-wrap flex-col-reverse lg:flex-row relative min-h-screen">
				<div className="px-4 pt-10 pb-6 lg:pb-0 lg:pl-10 xl:pr-48 lg:pr-28 lg:w-8/12 w-full flex flex-col">
					<HomeCarousel
						initialSlideIndex={SIGNUP_INITIAL_SLIDE_INDEX}
						onSlideChange={setSlideIndex}
					/>
					<div
						className="relative hidden lg:block z-0 transform translate-x-32 -translate-y-60"
						style={{ minHeight: "300px" }}
					>
						<HomeCarouselIllustration slideIndex={slideIndex} />
					</div>
				</div>
				<div className="lg:w-4/12 w-full p-5 lg:pt-0 pt-10">
					<SignupForm />

					<div className="c-divider">
						<span>{t("global.where")}</span>
					</div>

					<h3 className="font-bold text-center mb-4 block text-primary max-w-sm mx-auto">
						{t("signin.alreadySignedUp", {
							ns: "auth",
						})}
					</h3>

					<div className="flex justify-center">
						<Button
							className={"px-4"}
							link={publicRoutes.signin.path}
							variant="secondaryBordered"
						>
							{t("signin.connexion", {
								ns: "auth",
							})}
						</Button>
					</div>
				</div>
			</div>
		</>
	)
}
